/* JJ Shine, Oct 14 2026 (Jordan: "whenever something is added to cart, can you have a little animation that like...zooms it to the
   cart icon at the top right and makes it glow" / "pulsate"). The picture next to the Add to cart button that was pressed shrinks
   along a small arc into the header's cart icon, then the icon pulses with a blue glow.
   - Adds that stay on the page (Accessories, Bundles, the theme's own forms) announce themselves with the theme's "cart:update" event.
   - A plain Add to cart that goes on to the cart page (the product pages) is held for the flight (under a second), then goes on as before.
   - window.jjsFly(done) lets a page's own script play it before it moves on (snippets/jjs-pdp-upgrades.liquid).
   - Nothing flies from inside the cart drawer, and shoppers who ask their device for less motion get only the pulse. */
(function () {
  if (window.jjsFly) return;
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var css = '.jjs-fly{position:fixed;z-index:2147483000;pointer-events:none;object-fit:contain;background:#fff;border-radius:16px;box-shadow:0 14px 34px rgba(0,0,0,.35);will-change:transform,opacity;}' +
    '@keyframes jjsCartPulse{0%{transform:scale(1);filter:drop-shadow(0 0 0 rgba(26,127,255,0))}' +
    '18%{transform:scale(1.4);filter:drop-shadow(0 0 10px rgba(26,127,255,1)) drop-shadow(0 0 22px rgba(79,155,255,.85))}' +
    '36%{transform:scale(.94);filter:drop-shadow(0 0 6px rgba(26,127,255,.7))}' +
    '54%{transform:scale(1.24);filter:drop-shadow(0 0 10px rgba(26,127,255,1)) drop-shadow(0 0 18px rgba(79,155,255,.7))}' +
    '72%{transform:scale(.98);filter:drop-shadow(0 0 4px rgba(26,127,255,.5))}' +
    '100%{transform:scale(1);filter:drop-shadow(0 0 0 rgba(26,127,255,0))}}' +
    'cart-icon.jjs-cart-pulse,.header-actions__cart-icon.jjs-cart-pulse{animation:jjsCartPulse 1.5s ease-out;transform-origin:50% 50%;}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var SCOPES = '.jjsa-d, .jjsa-card, .jjsb-card, .jjspb-card, .jjs-fs__item, .jjspdp, .pdC, product-card, .product-card, .product-information, .product-grid__item, article, li';
  var press = null;
  function picNear(el) {
    var s = el.closest(SCOPES) || document;
    var l = [].slice.call(s.querySelectorAll('img')).filter(function (i) { var r = i.getBoundingClientRect(); return r.width > 30 && r.height > 30 && r.bottom > 0 && r.top < innerHeight; });
    return l[0] || null;
  }
  function remember(btn) {
    var img = picNear(btn), r = (img || btn).getBoundingClientRect();
    press = { at: Date.now(), rect: { left: r.left, top: r.top, width: r.width, height: r.height }, src: img ? (img.currentSrc || img.src) : null,
              inDrawer: !!btn.closest('cart-drawer-component, .cart-drawer, .cart-drawer__dialog') };
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button, input[type=submit]'); if (!b) return;
    var f = b.form || b.closest('form');
    var adds = f && /\/cart\/add/.test(f.getAttribute('action') || '') && (b.type || '').toLowerCase() !== 'button';
    if (adds || b.matches('.sb-btn, [data-jjs-add]')) remember(b);
  }, true);
  function icon() {
    return [].slice.call(document.querySelectorAll('cart-icon, .header-actions__cart-icon')).filter(function (i) { return i.getBoundingClientRect().width > 0; })[0] || null;
  }
  function pulse() {
    var i = icon(); if (!i) return;
    i.classList.remove('jjs-cart-pulse'); void i.offsetWidth; i.classList.add('jjs-cart-pulse');
    setTimeout(function () { i.classList.remove('jjs-cart-pulse'); }, 1600);
  }
  function fly(done) {
    var p = press, i = icon(); press = null;
    if (!p || Date.now() - p.at > 10000 || p.inDrawer || !i || reduce || !document.body.animate) { pulse(); if (done) setTimeout(done, 250); return; }
    var to = i.getBoundingClientRect(), s = Math.max(48, Math.min(160, Math.max(p.rect.width, p.rect.height)));
    var x0 = p.rect.left + p.rect.width / 2 - s / 2, y0 = p.rect.top + p.rect.height / 2 - s / 2;
    var g = document.createElement(p.src ? 'img' : 'div'); if (p.src) { g.src = p.src; g.alt = ''; }
    g.className = 'jjs-fly'; g.style.left = x0 + 'px'; g.style.top = y0 + 'px'; g.style.width = s + 'px'; g.style.height = s + 'px';
    document.body.appendChild(g);
    var dx = to.left + to.width / 2 - (x0 + s / 2), dy = to.top + to.height / 2 - (y0 + s / 2);
    var a = g.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx * 0.4 + 'px,' + (dy * 0.4 - 70) + 'px) scale(.6)', opacity: 1, offset: 0.42 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.1)', opacity: 0.5 }
    ], { duration: 800, easing: 'cubic-bezier(.5,.05,.35,1)', fill: 'forwards' });
    a.onfinish = function () { g.remove(); pulse(); if (done) setTimeout(done, 420); };
  }
  window.jjsFly = fly;
  document.addEventListener('cart:update', function (e) {
    var d = (e.detail && e.detail.data) || {}; if (d.didError) return;
    if (press && Date.now() - press.at < 10000) fly();
  });
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (e.defaultPrevented || !f || !/\/cart\/add/.test(f.getAttribute('action') || '') || f.getAttribute('data-jjs-flown')) return;
    if (!press || Date.now() - press.at > 3000 || press.inDrawer || reduce) return;
    e.preventDefault(); f.setAttribute('data-jjs-flown', '1');
    fly(function () { f.submit(); });
  });
})();
